import React, { useState } from "react";
import { Button, Modal, Row } from "react-bootstrap";
import { globalVars } from "../App";
import { myUtilities } from "../Utils";

const CardCheckBox = ({ invData, payMethod, callback }) => {
  let agreementType =
    payMethod === "dc"
      ? invData.state.dcAgreementType
      : invData.state.ccAgreementType;
  let agreementPath =
    payMethod === "dc"
      ? invData.state.DCAgreementpath
      : invData.state.CCAgreementpath;

  const [modalVisible, setModalVisiblity] = useState(false);

  const myref = React.createRef();

  const tnCWireFrame = (invData, agreementType, reference, agreementPath) => {
    return (
      <Row>
        {renderModal()}
        <div className="terms-and-conditions">
          <div style={{ display: "flex" }}>
            <div id="checkboxTnc" className="checkboxOne">
              <input
                ref={reference}
                title={showValidationMessage()}
                onInvalid={() =>
                  reference.current.setCustomValidity(
                    myUtilities.accountSpecificLanguage(
                      "form.validation.error",
                      "Please fill out this field."
                    )
                  )
                }
                type="checkbox"
                required
                id="myGlitchedCheckbox"
                onChange={() => {
                  globalVars.isTermsSelected = !globalVars.isTermsSelected;
                  callback(globalVars.isTermsSelected);
                }}
              />
              <label></label>
            </div>
            <label className="payment-tnc-label">
              {myUtilities.accountSpecificLanguage(
                "Terms.IAccept",
                "I accept the"
              )}{" "}
              <a
                href="#"
                className="terms-and-conditions-span"
                onClick={() =>
                  getOnClickOnTncType(agreementType, invData, agreementPath)
                }
              >
                {myUtilities.accountSpecificLanguage(
                  "Terms.TermsAndConditions",
                  "Terms and Conditions"
                )}
              </a>
            </label>
            <br />
          </div>
        </div>
      </Row>
    );
  };

  const showValidationMessage = () =>
    globalVars.isTermsSelected
      ? ""
      : myUtilities.accountSpecificLanguage(
          "form.validation.error",
          "Please fill out this field."
        );

  const renderModal = () => (
    <Modal show={modalVisible} centered>
      <Modal.Body className="payment-tnc-modal">
        <td
          dangerouslySetInnerHTML={{
            __html: agreementPath,
          }}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={() => setModalVisiblity(false)}>
          {myUtilities.accountSpecificLanguage("AlertDialog.Ok", "Ok")}
        </Button>
      </Modal.Footer>
    </Modal>
  );

  const getOnClickOnTncType = (typeOfAgreement, invData, agreementPath) => {
    switch (typeOfAgreement) {
      case "staticLink":
        window.open(agreementPath, "_blank");
        break;
      case "html":
        setModalVisiblity(true);
        break;
      case "s3Path":
        let token = invData.state.token
          ? invData.state.token
          : window.location.search.substring(7, window.location.search.length);
        let fileName =
          "/radiusoneweb/securedFileDownload?file=" +
          agreementPath.trim() +
          "&token=" +
          encodeURIComponent(token) +
          "&src=TC";
        window.open(fileName);
        break;
      default:
        break;
    }
  };

  if (
    agreementType === "staticLink" ||
    agreementType === "html" ||
    agreementType === "s3Path"
  )
    return tnCWireFrame(invData, agreementType, myref, agreementPath);
  else {
    return (
      <Row>
        <div className="terms-and-conditions" />
      </Row>
    );
  }
};

export default CardCheckBox;
